module.exports = __webpack_public_path__ + "img/shop-tree-new.6010108a.png";